import React, { useState } from "react";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsPaginationObj } from '../../analytics/analyticsObject';
import { makeRequest } from "../../utils/request";

const SearchBar = ({ canProceed, searchProps, searchresultsCount, hasAccessUntil,hasAccess, isMember }) => {
    let subStatus = "";
  const [searchKey, setSearchKey] = useState('');
  const searchDisplayVal = searchKey || searchProps.searchValue || ''
  const clearSearch = () => {
    setSearchKey("");
    searchProps.setSearchValue("");
    searchProps.setAppliedSearch("");
    window.scrollTo(0, 0);
  };
  const submitSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (canProceed()) {
      searchProps.submitSearch();
      window.scrollTo(0, 0);
    }
  };
  const searchEnter = (e) => {
    if (e.key === 'Enter') {
      const targetValue = updateSearchValue(e.target.value) //e.target.value || ''
      searchProps.setSearchValue(targetValue)
      setSearchKey(targetValue)
      onTriggerSearch(targetValue)
    }
  }
  const updateSearchValue = (value = '') => {
    const pattern = /(\s|^)((\d+\.)(\d+\.?)+)(\s|$)/g;
    return value.replace(pattern, '$1"$2"$5');
  };
  const searchChange = (e) => {
    if (e.target.value.length === 0) {
      clearSearch()
    }
    setSearchKey(e.target.value)
  }
  const searchIconClick = (e, searchDisplayVal) => {
    const targetValue = updateSearchValue(searchDisplayVal);
    searchProps.setSearchValue(targetValue);
    searchProps.setAppliedSearch(targetValue);
    onTriggerSearch(targetValue)

  }
  const onTriggerSearch = async (targetValue) => {
     if (hasAccess && hasAccess == true) {
            if (isMember == true) {
                subStatus = "subscribed:pmi_membership"
            }
            else {
                subStatus = "subscribed:stdplus_subscription"
            }
        }
        else {
            subStatus = "Non-subscribed"
        }
    const excludeValue = "CTVerbatim,CTToc";
    const excludeFiltersDefault = [{
      filterkey: "contenttypeid",
      filtervalue: null,
      excludevalue: excludeValue
    }]
    const newPageData = {
      filters: [],
      language: "En",
      page: 1,
      pageSize: 10,
      searchText: targetValue,
      sortBy: "publisheddate",
      sortType: "desc",
    }
    const contentItems = await makeRequest("POST", `/api/content/contentItems`, newPageData);
    if (contentItems && contentItems.totalCount > 0) {

      let searchOnLoad = {
        event: "search-load",
        eventInfo: "search-load",
        action: "search-success",
        search: {
          searchTerm: targetValue,
          searchResults: contentItems.totalCount,
          searchFilter: "not available",
          searchSort: "relevance",
          searchType: "standadrplus",
          searchPagination: "1",
        }
      }
      let subscriptionStatus = {

        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate: hasAccessUntil.split('T')[0],
          subStatus:subStatus,
        }
      }
      pushDatatoAdobeLayer({ searchOnLoad, subscriptionStatus })

    }
    else {
      let searchNoResults = {
        event: "search-load",
        eventInfo: "search-load",
        action: "search-no-results",
        search: {
          searchTerm: targetValue,
          searchResults: 'no results found',
          searchFilter: "not available",
          searchSort: "relevance",
          searchType: "standadrplus",
          searchPagination: "1",
        }
      }
      let subscriptionStatus = {

        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate: hasAccessUntil.split('T')[0],
          subStatus:subStatus,
        }
      }
      pushDatatoAdobeLayer({ searchNoResults, subscriptionStatus })

    }
  }
  return (
    <form className="relative w-full" onSubmit={(e) => submitSearch(e)}>
      <input
        className="mt-1 appearance-none border border-gray-500 rounded w-full py-3 pl-4 pr-16 text-black leading-tight focus:outline-none focus:shadow-outline"
        type="text"
        maxLength="150"
        value={searchDisplayVal}
        onChange={(e) => searchChange(e)}
        placeholder="Search for all things in project management"
        title="When searching for something specific, try using quotes"
        onKeyDown={(e) => searchEnter(e)}
      />
      {searchDisplayVal !== "" && (
        <i
          className="fas fa-times absolute text-gray-700 hover:text-black cursor-pointer"
          style={{ top: "18px", right: "40px" }}
          onClick={() => clearSearch()}
        ></i>
      )}
      <i
        className="fas fa-search absolute text-blue-700 cursor-pointer"
        style={{ top: "18px", right: "10px" }}
        onClick={(e) => searchIconClick(e, searchDisplayVal)}
      ></i>
    </form>
  );
};

export default SearchBar;
